import * as adminApi from 'api/adminApi';
import { getLocalization } from 'global/global';
import { CampaignDraft } from 'Interfaces/Admin';
import { upsertCampaign } from 'reducers/admin/campaigns';
import { showAlert } from './index';
import { pendingToast } from './adminToast';

/** Replaces WebContent-src/admin/sync/CampaignSync.js. */
export const saveCampaign = (campaign: CampaignDraft) => {
  return async (dispatch): Promise<boolean> => {
    const isNew = !campaign.id;
    const notify = pendingToast(getLocalization('savingCampaign'));
    try {
      const response = await adminApi.saveCampaign(campaign);
      if (response.status !== 'OK' || !response.campaign) {
        notify.fail(
          response.errorCode
            ? getLocalization(`error${response.errorCode}`)
            : getLocalization('errorSavingCampaign'),
        );
        if (response.errorMessage) {
          dispatch(showAlert({ visible: true, message: response.errorMessage }));
        }
        return false;
      }
      notify.succeed(getLocalization('campaignSaved'));
      dispatch(upsertCampaign(response.campaign));
      if (isNew && response.campaign.campaignUrl) {
        dispatch(showAlert({
          visible: true,
          message: `${getLocalization('campaignUrlInfo')} ${response.campaign.campaignUrl}`,
        }));
      }
      return true;
    } catch (e) {
      console.log(e);
      notify.fail(getLocalization('errorSavingCampaign'));
      return false;
    }
  };
};
